"use strict";

// Dev
var stripe = Stripe('pk_test_51QT327GXJbmXaFaxtb7NPXhTs8in9renXo1vVyz1F6cQM9QXcUr2JsXQj7GHiTFFWIEq7IxmTSzqomUQTDSEZdcl00WIC2BIpy');
console.log('Dev Stripe');
//# sourceMappingURL=../../dist/javascript/maps/signupdevkey.js.map
